import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

export type ImagePosition = 'inline' | 'banner' | 'background';

interface ImagePositionPickerProps {
  value: ImagePosition;
  onChange: (position: ImagePosition) => void;
}

export function ImagePositionPicker({
  value,
  onChange,
}: ImagePositionPickerProps) {
  return (
    <div>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 0.5, display: 'block' }}
      >
        Image position
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) onChange(newValue as ImagePosition);
        }}
        size="small"
      >
        <ToggleButton value="inline" sx={{ textTransform: 'none', px: 1.5 }}>
          Inline
        </ToggleButton>
        <ToggleButton value="banner" sx={{ textTransform: 'none', px: 1.5 }}>
          Banner
        </ToggleButton>
        <ToggleButton
          value="background"
          sx={{ textTransform: 'none', px: 1.5 }}
        >
          Background
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}
